import { Card, CardContent } from '@/components/ui/card'
import { columns } from './columns'
import { DataTable } from './data-table'
import { useInvestorClinics } from '@/hooks/useInvestorClinics'
import { Skeleton } from '@/components/ui/skeleton'
import { InvestorDeviceStatsCard } from '@/components/InvestorDeviceStatsCard'

export default function InvestorClinicsPage() {
  const { clinics, isLoading, isError, mutate } = useInvestorClinics()

  if (isError) {
    return (
      <div>
        <div className="text-center text-destructive">載入診所列表失敗。請稍後再試。</div>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div>
        <Skeleton className="h-8 w-[200px] mb-4" />
        <Skeleton className="h-[400px] w-full" />
      </div>
    )
  }

  return (
    <div>
      <div>
        <h1 className="text-3xl font-bold tracking-tight">診所列表</h1>
        <p className="text-muted-foreground mt-2">查看診所資訊及廣告成效</p>
      </div>

      <div className="h-4" />

      {/* 設備連接狀態監控 */}
      <InvestorDeviceStatsCard />

      <div className="h-4" />

      <Card>
        <CardContent className="p-6">
          <DataTable
            columns={columns}
            data={clinics || []}
            meta={{
              reloadData: () => mutate(),
            }}
          />
        </CardContent>
      </Card>
    </div>
  )
}
